import React from "react";
import QRCode from "react-qr-code";
import styled from "styled-components";

const StyledQRCode = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledDomain = styled.div`
  font-size: 1.5rem;
`;

const ActivityQRCode = (props: { url: string; domain: string }) => {
  return (
    <div>
      <StyledQRCode>
        <QRCode value={props.url} />
      </StyledQRCode>
      <StyledDomain>{props.domain.replace(/^http?s:\/\//, "")}</StyledDomain>
    </div>
  );
};

export default ActivityQRCode;
